<div class="container-fluid principal">
	<ng-container *ngIf="!show_detailed_cash_close">
		<div class="row py-3 border-bottom">
			<div class="col-12">
				<h4>Corte de caja personal</h4>
			</div>
		</div>
		<div class="row my-3">
			<div class="col-6">
				<div>Inicio sesión actual:</div>
				<div>{{this.rest.session_start | date:'MMM d, y, h:mm a'}}</div>
			</div>
			<div class="col-6"></div>
		</div>
		<div class="text-center">
		</div>
		<h5>
			Registro de cortes pasados
			<a [routerLink]="['/list-cash-close']" class="btn btn-primary btn-sm">Ver Todos</a>
		</h5>
		<div class="row mt-3">
			<div class="col-2">Folio</div>
			<div class="col-5">Inicio</div>
			<div class="col-5">Fin</div>
		</div>
		<ng-container  *ngFor="let cash_close of cash_close_list">
			<div class="row pointer py-1" [routerLink]="['/print-corte',rest.local_preferences.default_cash_close_receipt,cash_close.id]">
				<div class="col-2">{{cash_close.id }}</div>
				<div class="col-5">{{cash_close.start | date: 'MMM d, y, h:mm a'}}</div>
				<div class="col-5">{{cash_close.end | date: 'MMM d, y, h:mm a'}}</div>
			</div>
		</ng-container>
		<ng-container *ngIf="rest.local_preferences.default_cash_close_type === 'DETAILED'">
			<div class="row my-3">
				<div class="col-md-6">
					<button type="button" class="w-100 btn btn-danger" [disabled]="is_loading" (click)="closeModal()">Cancelar</button>
				</div>
				<div class="col-md-6">
					<button class="w-100 btn btn-success" [disabled]="is_loading" (click)="show_detailed_cash_close = true">Crear nuevo corte</button>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="rest.local_preferences.default_cash_close_type !== 'DETAILED'">
			<form name="cash-close" (submit)="onCashCloseSubmit($event)" ngNativeValidate>
				<div class="row p-3 mt-3 border-top">
					<div class="col-6">
						<label>Pesos</label>
						<input type="number" step="any" min="0" name="cash_on_hand" [(ngModel)]="cash_on_hand" class="form-control" required>
					</div>
					<div class="col-6">
						<label>Dolares</label>
						<input type="number" step="any" min="0" name="cash_usd" [(ngModel)]="cash_dolares" class="form-control" required>
					</div>
					<div class="col-6">
						<label>&nbsp;</label>
						<button type="button" class="w-100 btn btn-danger" [disabled]="is_loading" (click)="closeModal()">Cancelar</button>
					</div>
					<div class="col-6">
						<label>&nbsp;</label>
						<div>
							<button type="submit" class="w-100 btn btn-success" [disabled]="is_loading">Crear nuevo corte</button>
						</div>
					</div>
				</div>
			</form>
		</ng-container>
	</ng-container>

	<ng-container *ngIf="show_detailed_cash_close">
		<form name="cash-close" (submit)="onCashCloseSubmit($event)" ngNativeValidate>
			<div class="container mt-4">
				<div class="row my-3">
					<div class="col-md-6">
					<h5 class="fw-bold">BILLETES EN MONEDA NACIONAL</h5>
					<table class="table">
						<thead>
						<tr>
							<th>Denominación</th>
							<th>Cantidad</th>
							<th>Total</th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td>$ 1000.00</td>
							<td><input type="number" class="form-control" name="mxn_1000_bill" required/></td>
							<td class="text-end">{{ getSubtotal('mxn_1000_bill', 1000) | currency:'$' }}</td>
						</tr>
						<tr>
							<td>$ 500.00</td>
							<td><input type="number" class="form-control" name="mxn_500_bill" required/></td>
							<td class="text-end">{{ getSubtotal('mxn_500_bill', 500) | currency:'$' }}</td>
						</tr>
						<tr>
							<td>$ 200.00</td>
							<td><input type="number" class="form-control" name="mxn_200_bill" required/></td>
							<td class="text-end">{{ getSubtotal('mxn_200_bill', 200) | currency:'$' }}</td>
						</tr>
						<tr>
							<td>$ 100.00</td>
							<td><input type="number" class="form-control" name="mxn_100_bill" required/></td>
							<td class="text-end">{{ getSubtotal('mxn_100_bill', 100) | currency:'$' }}</td>
						</tr>
						<tr>
							<td>$ 50.00</td>
							<td><input type="number" class="form-control" name="mxn_50_bill" required/></td>
							<td class="text-end">{{ getSubtotal('mxn_50_bill', 50) | currency:'$' }}</td>
						</tr>
						<tr>
							<td>$ 20.00</td>
							<td><input type="number" class="form-control" name="mxn_20_bill" required/></td>
							<td class="text-end">{{ getSubtotal('mxn_20_bill', 20) | currency:'$' }}</td>
						</tr>
						</tbody>
						<tfoot>
						<tr>
							<th colspan="2">TOTAL</th>
							<th>{{ getTotalCashCountForm('mxn_', 'bill') | currency:'$' }}</th>
						</tr>
						</tfoot>
					</table>
					</div>

					<div class="col-md-6">
					<h5 class="fw-bold">BILLETES EN DOLARES</h5>
						<table class="table">
							<thead>
								<tr>
									<th>Denominación</th>
									<th>Cantidad</th>
									<th>Total</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>$ 100.00</td>
									<td><input type="number" class="form-control" name="usd_100_bill" required/></td>
									<td class="text-end">{{ getSubtotal('usd_100_bill', 100) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 50.00</td>
									<td><input type="number" class="form-control" name="usd_50_bill" required/></td>
									<td class="text-end">{{ getSubtotal('usd_50_bill',50) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 20.00</td>
									<td><input type="number" class="form-control" name="usd_20_bill" required/></td>
									<td class="text-end">{{ getSubtotal('usd_20_bill', 20) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 10.00</td>
									<td><input type="number" class="form-control" name="usd_10_bill" required/></td>
									<td class="text-end">{{ getSubtotal('usd_10_bill', 10) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 5.00</td>
									<td><input type="number" class="form-control" name="usd_5_bill" required/></td>
									<td class="text-end">{{ getSubtotal('usd_5_bill', 5) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 1.00</td>
									<td><input type="number" class="form-control" name="usd_1_bill" required/></td>
									<td class="text-end">{{ getSubtotal('usd_1_bill', 1) | currency:'$' }}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<th colspan="2">TOTAL</th>
									<th>{{ getTotalCashCountForm('usd_', 'bill') | currency:'$' }}</th>
								</tr>
								<tr>
									<th colspan="2">EQUIVALENTE M.N.</th>
									<th class="text-end">
										{{ getTotalInMXNCashCountForm('usd_', 'bill') | currency:'$' }}
									</th>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>

				<div class="row my-3">
					<div class="col-md-6">
						<h5 class="fw-bold">MONEDAS M.N.</h5>
						<table class="table">
							<thead>
								<tr>
									<th>Denominación</th>
									<th>Cantidad</th>
									<th>Total</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>$ 20.00</td>
									<td><input type="number" class="form-control" name="mxn_20_coin" required/></td>
									<td class="text-end">{{ getSubtotal('mxn_20_coin', 20) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 10.00</td>
									<td><input type="number" class="form-control" name="mxn_10_coin" required/></td>
									<td class="text-end">{{ getSubtotal('mxn_10_coin', 10) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 5.00</td>
									<td><input type="number" class="form-control" name="mxn_5_coin" required/></td>
									<td class="text-end">{{ getSubtotal('mxn_5_coin', 5) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 2.00</td>
									<td><input type="number" class="form-control" name="mxn_2_coin" required/></td>
									<td class="text-end">{{ getSubtotal('mxn_2_coin', 2) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 1.00</td>
									<td><input type="number" class="form-control" name="mxn_1_coin" required/></td>
									<td class="text-end">{{ getSubtotal('mxn_1_coin', 1) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 0.50</td>
									<td><input type="number" class="form-control" name="mxn_0.5_coin" required/></td>
									<td class="text-end">{{ getSubtotal('mxn_0.5_coin', 0.5) | currency:'$' }}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<th colspan="2">TOTAL</th>
									<th>{{ getTotalCashCountForm('mxn_', 'coin') | currency:'$' }}</th>
								</tr>
							</tfoot>
						</table>
					</div>

					<div class="col-md-6">
						<h5 class="fw-bold">MONEDAS EN DOLARES</h5>
						<table class="table">
							<thead>
								<tr>
									<th>Denominación</th>
									<th>Cantidad</th>
									<th>Total</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>$ 1.00</td>
									<td><input type="number" class="form-control" name="usd_1_coin" required/></td>
									<td class="text-end">{{ getSubtotal('usd_1_coin', 1) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 0.25</td>
									<td><input type="number" class="form-control" name="usd_0.25_coin" required/></td>
									<td class="text-end">{{ getSubtotal('usd_0.25_coin', 0.25) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 0.10</td>
									<td><input type="number" class="form-control" name="usd_0.10_coin" required/></td>
									<td class="text-end">{{ getSubtotal('usd_0.10_coin', 0.10) | currency:'$' }}</td>
								</tr>
								<tr>
									<td>$ 0.05</td>
									<td><input type="number" class="form-control" name="usd_0.05_coin" required/></td>
									<td class="text-end">{{ getSubtotal('usd_0.05_coin', 0.05) | currency:'$' }}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<th colspan="2">TOTAL</th>
									<th>{{ getTotalCashCountForm('usd_', 'coin') | currency:'$' }}</th>
								</tr>
								<tr>
									<th colspan="2">EQUIVALENTE M.N.</th>
									<th class="text-end">
										{{ getTotalInMXNCashCountForm('usd_', 'coin') | currency:'$' }}
									</th>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>

				<div class="row my-3">
					<div class="col-md-12">
						<h5 class="fw-bold">INGRESOS NO FÍSICOS</h5>
						<table class="table">
						<thead>
							<tr>
							<th>Método</th>
							<th>Monto total recibido</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Tarjeta Crédito</td>
								<td><input type="number" step="any" min="0" class="form-control" name="mxn_1_credit_card" required/></td>
							</tr>
							<tr>
								<td>Tarjeta Débito</td>
								<td><input type="number" step="any" min="0" class="form-control" name="mxn_1_debit_card" required/></td>
							</tr>
							<tr>
								<td>Cheque</td>
								<td><input type="number" step="any" min="0" class="form-control" name="mxn_1_check" required/></td>
							</tr>
							<tr>
								<td>Transferencia</td>
								<td><input type="number" step="any" min="0" class="form-control" name="mxn_1_transfer" required/></td>
							</tr>
						</tbody>
						</table>
					</div>
				</div>

				<div class="row p-3 mt-3 border-top">
					<div class="col-6">
						<label>&nbsp;</label>
						<button type="button" class="w-100 btn btn-danger" [disabled]="is_loading" (click)="closeModal()">Cancelar</button>
					</div>
					<div class="col-6">
						<label>&nbsp;</label>
						<div>
							<button type="submit" class="w-100 btn btn-success" [disabled]="is_loading">Crear nuevo corte</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</ng-container>
</div>
